import React from 'react';
import { SEO } from '../components/SEO';
export const TermsPage = () => {
  return <main data-id="element-1697" data-mp="259bcjjr5sb2x">
      <SEO title="Algemene Voorwaarden | BKCustoms" description="Lees onze algemene voorwaarden. Informatie over garantie, betalingen en andere belangrijke voorwaarden bij BKCustoms auto styling diensten." canonical="/algemene-voorwaarden" data-id="element-1698" data-mp="259l3panxwoa7" />
      {/* Header Banner */}
      <div className="relative bg-[#0a0a0a] py-20" data-id="element-1699" data-mp="2f9lpr4d71ii3">
        <div className="absolute inset-0 overflow-hidden" data-id="element-1700" data-mp="2t5yztsfeehmj">
          <div className="absolute inset-0 bg-black/90 z-10" data-id="element-1701" data-mp="2o7xhxatpkocn"></div>
          <img src="https://images.unsplash.com/photo-1557597774-9d273605dfa9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Algemene Voorwaarden" className="w-full h-full object-cover object-center" data-id="element-1702" data-mp="2o7notedda12q" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-1703" data-mp="3byb62q96a31y">
          <h1 className="text-4xl font-bold text-white mb-6" data-id="element-1704" data-mp="37wy3cp1dmfz9">
            Algemene Voorwaarden
          </h1>
        </div>
      </div>
      {/* Content Section */}
      <section className="bg-[#0a0a0a] py-16" data-id="element-1705" data-mp="2zosy3cs05fyr">
        <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-1706" data-mp="2zpkmo3n6mdfj">
          <div className="bg-[#0f0f0f] border border-[#222] rounded-lg p-8 md:p-10" data-id="element-1707" data-mp="34o5m40um0t2x">
            <div className="prose prose-invert max-w-none" data-id="element-1708" data-mp="39mz0rwlmuq4o">
              <p className="text-white/80 mb-6" data-id="element-1709" data-mp="39ojuxl41c720">
                <strong data-id="element-1710" data-mp="3emblaap17l43">Laatst bijgewerkt: 1 juni 2023</strong>
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1711" data-mp="3ek8x7w7fw220">
                1. Algemeen
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1712" data-mp="3nenf86jctqot">
                Deze algemene voorwaarden zijn van toepassing op alle
                aanbiedingen, werkzaamheden, offertes en overeenkomsten tussen
                BKCustoms, hierna te noemen "Opdrachtnemer", en een
                Opdrachtgever waarop Opdrachtnemer deze voorwaarden van
                toepassing heeft verklaard.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1713" data-mp="3cn8xjdv8rdyj">
                2. Offertes en aanbiedingen
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1714" data-mp="37pqn1j1ksqof">
                Alle offertes en aanbiedingen van Opdrachtnemer zijn
                vrijblijvend en hebben een geldigheidsduur van 30 dagen, tenzij
                anders aangegeven. Een offerte of aanbieding vervalt indien het
                product waarop de offerte of de aanbieding betrekking heeft in
                de tussentijd niet meer beschikbaar is.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1715" data-mp="3qgzwjsbcjfg0">
                3. Uitvoering van de overeenkomst
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1716" data-mp="475szgzfe5ef">
                Opdrachtnemer zal de overeenkomst naar beste inzicht en vermogen
                en overeenkomstig de eisen van goed vakmanschap uitvoeren. Alle
                werkzaamheden worden uitgevoerd op basis van een
                inspanningsverbintenis.
              </p>
              <p className="text-white/80 mb-4" data-id="element-1717" data-mp="licgaoqbra5w">
                Opdrachtgever draagt er zorg voor dat alle gegevens, waarvan
                Opdrachtnemer aangeeft dat deze noodzakelijk zijn voor het
                uitvoeren van de overeenkomst, tijdig aan Opdrachtnemer worden
                verstrekt.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1718" data-mp="go83houdo7ww">
                4. Betaling en incassokosten
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1719" data-mp="6smx7eia0lhc">
                Betaling dient steeds te geschieden binnen 14 dagen na
                factuurdatum, tenzij schriftelijk anders overeengekomen. Voor
                bepaalde diensten kan een aanbetaling worden gevraagd.
              </p>
              <p className="text-white/80 mb-4" data-id="element-1720" data-mp="1n6dcziircy6t">
                Indien de Opdrachtgever in gebreke blijft in de tijdige betaling
                van een factuur, dan is de Opdrachtgever van rechtswege in
                verzuim. De Opdrachtgever is dan de wettelijke rente
                verschuldigd.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1721" data-mp="3j99rj69qw95n">
                5. Garantie
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1722" data-mp="3f6liaxh4d085">
                Opdrachtnemer biedt garantie op de uitgevoerde werkzaamheden en
                gebruikte materialen conform de garantievoorwaarden die bij de
                offerte worden vermeld. De garantietermijn varieert per dienst:
              </p>
              <ul className="list-disc pl-6 text-white/80 mb-4" data-id="element-1723" data-mp="30i8mc0i17hdn">
                <li data-id="element-1724" data-mp="2vjfhsxkq30pm">Carwraps: 3 jaar garantie op materiaal en installatie</li>
                <li data-id="element-1725" data-mp="2ric2qdai18pg">
                  Raamtinting: 5 jaar garantie tegen verkleuring en loslaten
                </li>
                <li data-id="element-1726" data-mp="2mjsc3zkyn8qr">
                  Overige diensten: garantietermijn wordt per dienst
                  gespecificeerd
                </li>
              </ul>
              <p className="text-white/80 mb-4" data-id="element-1727" data-mp="2hm8yn1w36zzv">
                Garantie vervalt bij oneigenlijk gebruik, aanpassingen door
                derden, of schade veroorzaakt door externe factoren.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1728" data-mp="170bacahvhtui">
                6. Aansprakelijkheid
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1729" data-mp="1b2ekmvst2se7">
                Opdrachtnemer is uitsluitend aansprakelijk voor directe schade
                die is ontstaan door bewuste roekeloosheid of opzet van
                Opdrachtnemer. Onder directe schade wordt uitsluitend verstaan
                de redelijke kosten ter vaststelling van de oorzaak en de omvang
                van de schade, de eventuele redelijke kosten gemaakt om de
                gebrekkige prestatie van Opdrachtnemer aan de overeenkomst te
                laten beantwoorden en redelijke kosten gemaakt ter voorkoming of
                beperking van schade.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1730" data-mp="3vqaq3lrihfv7">
                7. Vrijwaring
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1731" data-mp="xyk68psuy14c">
                De Opdrachtgever vrijwaart Opdrachtnemer voor eventuele
                aanspraken van derden, die in verband met de uitvoering van de
                overeenkomst schade lijden en waarvan de oorzaak aan andere dan
                aan Opdrachtnemer toerekenbaar is.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1732" data-mp="jzkhli5chm86">
                8. Intellectuele eigendom
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1733" data-mp="f1ss0us6ac75">
                Opdrachtnemer behoudt zich de rechten en bevoegdheden voor die
                hem toekomen op grond van de Auteurswet en andere intellectuele
                wet- en regelgeving.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1734" data-mp="24dl6h7ox15gq">
                9. Toepasselijk recht en geschillen
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1735" data-mp="20fdne66zbs2d">
                Op alle rechtsbetrekkingen waarbij Opdrachtnemer partij is, is
                uitsluitend het Nederlands recht van toepassing. De rechtbank in
                de vestigingsplaats van Opdrachtnemer is bij uitsluiting bevoegd
                van geschillen kennis te nemen.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1736" data-mp="22yidk1n70hxi">
                10. Wijziging voorwaarden
              </h2>
              <p className="text-white/80" data-id="element-1737" data-mp="2qp4n5xcuia9m">
                Opdrachtnemer is bevoegd wijzigingen in deze voorwaarden aan te
                brengen. Deze wijzigingen treden in werking op het aangekondigde
                tijdstip van inwerkingtreding. Opdrachtnemer zal de gewijzigde
                voorwaarden tijdig aan de Opdrachtgever toezenden.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>;
};